// Generated by robots, do not change this manually!
/** Базовый белый цвет совпадает с whitePrimary */
export var white = 'var(--plasma-colors-white, #FFFFFF)';
/** Первичный белый цвет */
export var whitePrimary = 'var(--plasma-colors-white-primary, #FFFFFF)';
/** Вторичный белый цвет */
export var whiteSecondary = 'var(--plasma-colors-white-secondary, rgba(255, 255, 255, 0.56))';
/** Третичный белый цвет */
export var whiteTertiary = 'var(--plasma-colors-white-tertiary, rgba(255, 255, 255, 0.28))';
/** Базовый черный цвет совпадает с blackPrimary */
export var black = 'var(--plasma-colors-black, #080808)';
/** Первичный черный цвет */
export var blackPrimary = 'var(--plasma-colors-black-primary, #080808)';
/** Вторичный черныйцвет */
export var blackSecondary = 'var(--plasma-colors-black-secondary, rgba(8, 8, 8, 0.56))';
/** Третичный черный цвет */
export var blackTertiary = 'var(--plasma-colors-black-tertiary, rgba(8, 8, 8, 0.28))';
/** Чёрный непрозрачный, не зависит от темы */
export var dark01 = 'var(--plasma-colors-dark01, #171717)';
/** Чёрный непрозрачный, не зависит от темы */
export var dark02 = 'var(--plasma-colors-dark02, #232323)';
/** Чёрный непрозрачный, не зависит от темы */
export var dark03 = 'var(--plasma-colors-dark03, #363636)';
/** Прозрачный цвет */
export var transparent = 'var(--plasma-colors-transparent, rgba(0, 0, 0, 0))';
/** Второстепенная прозрачная */
export var buttonClear = 'var(--plasma-colors-button-clear, rgba(0, 0, 0, 0))';
/** Дефолтная чёрная, не зависит от темы */
export var buttonBlack = 'var(--plasma-colors-button-black, #080808)';
/** Второстепенная чёрная, не зависит от темы */
export var buttonBlackSecondary = 'var(--plasma-colors-button-black-secondary, rgba(8, 8, 8, 0.12))';
/** Чёрная для использования поверх картинок */
export var buttonBlackTransparent = 'var(--plasma-colors-button-black-transparent, rgba(8, 8, 8, 0.56))';
/** Дефолтная белая, не зависит от темы */
export var buttonWhite = 'var(--plasma-colors-button-white, #FFFFFF)';
/** Второстепенная белая, не зависит от темы */
export var buttonWhiteSecondary = 'var(--plasma-colors-button-white-secondary, rgba(255, 255, 255, 0.12))';
/** Базовый цвет текста, совпадает с primary */
export var text = 'var(--plasma-colors-text, #080808)';
export var link = 'var(--plasma-colors-link, #2A72F8)';
export var linkHover = 'var(--plasma-colors-link-hover, #4D89F9)';
export var linkActive = 'var(--plasma-colors-link-active, #0859F1)';
export var linkVisited = 'var(--plasma-colors-link-visited, #2364DE)';
export var linkVisitedHover = 'var(--plasma-colors-link-visited-hover, #427AE3)';
export var linkVisitedActive = 'var(--plasma-colors-link-visited-active, #1C54BC)';
/** Основной текст в интерфейсе */
export var primary = 'var(--plasma-colors-primary, #080808)';
/** Второстепенный текст */
export var secondary = 'var(--plasma-colors-secondary, rgba(8, 8, 8, 0.56))';
/** Третичный цвет текста */
export var tertiary = 'var(--plasma-colors-tertiary, rgba(8, 8, 8, 0.28))';
export var paragraph = 'var(--plasma-colors-paragraph, rgba(8, 8, 8, 0.8))';
export var inverse = 'var(--plasma-colors-inverse, rgba(255, 255, 255, 0.96))';
/** Основной бэкграунд всех приложений и смартапов */
export var background = 'var(--plasma-colors-background, #FFFFFF)';
/** Первичный цвет фона */
export var backgroundPrimary = 'var(--plasma-colors-background-primary, #FFFFFF)';
/** Вторичный цвет фона */
export var backgroundSecondary = 'var(--plasma-colors-background-secondary, #FFFFFF)';
/** Третичный цвет фона */
export var backgroundTertiary = 'var(--plasma-colors-background-tertiary, #FFFFFF)';
export var inputBorder = 'var(--plasma-colors-input-border, rgba(8, 8, 8, 0.28))';
export var inputBorderHover = 'var(--plasma-colors-input-border-hover, rgba(8, 8, 8, 0.56))';
export var inputBorderFocus = 'var(--plasma-colors-input-border-focus, #2A72F8)';
/** Акцентный цвет бренда */
export var accent = 'var(--plasma-colors-accent, #2A72F8)';
/** Обозначение успешного сценария */
export var success = 'var(--plasma-colors-success, #118C28)';
/** Цвет предупреждения */
export var warning = 'var(--plasma-colors-warning, #E35502)';
/** Цвет ошибки */
export var critical = 'var(--plasma-colors-critical, #F31B30)';
/** Полупрозрачные поверхности */
export var surfaceLiquid01 = 'var(--plasma-colors-surface-liquid01, rgba(8, 8, 8, 0.02))';
/** Полупрозрачные поверхности */
export var surfaceLiquid02 = 'var(--plasma-colors-surface-liquid02, rgba(8, 8, 8, 0.06))';
/** Полупрозрачные поверхности */
export var surfaceLiquid03 = 'var(--plasma-colors-surface-liquid03, rgba(8, 8, 8, 0.12))';
/** Непрозрачные поверхности */
export var surfaceSolid01 = 'var(--plasma-colors-surface-solid01, #FAFAFA)';
/** Непрозрачные поверхности */
export var surfaceSolid02 = 'var(--plasma-colors-surface-solid02, #F0F0F0)';
/** Непрозрачные поверхности */
export var surfaceSolid03 = 'var(--plasma-colors-surface-solid03, #E1E1E1)';
/** Основной фон для карточек */
export var surfaceCard = 'var(--plasma-colors-surface-card, #FFFFFF)';
/** Первичный цвет контролов */
export var buttonPrimary = 'var(--plasma-colors-button-primary, #2A72F8)';
export var buttonPrimaryHover = 'var(--plasma-colors-button-primary-hover, #397CF8)';
export var buttonPrimaryActive = 'var(--plasma-colors-button-primary-active, #1B68F8)';
/** Второстепенная кнопка */
export var buttonSecondary = 'var(--plasma-colors-button-secondary, rgba(8, 8, 8, 0.06))';
export var buttonSecondaryHover = 'var(--plasma-colors-button-secondary-hover, rgba(8, 8, 8, 0.04))';
export var buttonSecondaryActive = 'var(--plasma-colors-button-secondary-active, rgba(8, 8, 8, 0.08))';
/** Акцентный цвет у контролов */
export var buttonAccent = 'var(--plasma-colors-button-accent, #2A72F8)';
/** Кнопка для успешного сценария */
export var buttonSuccess = 'var(--plasma-colors-button-success, #118C28)';
export var buttonSuccessHover = 'var(--plasma-colors-button-success-hover, #3eaa4d)';
export var buttonSuccessActive = 'var(--plasma-colors-button-success-active, #1d9233)';
/** Цвет предупреждения у контролов */
export var buttonWarning = 'var(--plasma-colors-button-warning, #F55D05)';
export var buttonWarningHover = 'var(--plasma-colors-button-warning-hover, #FA650F)';
export var buttonWarningActive = 'var(--plasma-colors-button-warning-active, #E65705)';
/** Цвет ошибки у контролов */
export var buttonCritical = 'var(--plasma-colors-button-critical, #F31B30)';
export var buttonCriticalHover = 'var(--plasma-colors-button-critical-hover, #F42A3E)';
export var buttonCriticalActive = 'var(--plasma-colors-button-critical-active, #F20D24)';
/** Цвет зажатого контрола */
export var buttonChecked = 'var(--plasma-colors-button-checked, #080808)';
export var buttonCheckedHover = 'var(--plasma-colors-button-checked-hover, #171717)';
export var buttonCheckedHoverColor = 'var(--plasma-colors-button-checked-hover-color, hsla(0, 0%, 100%, 0.9599999785423279))';
export var buttonCheckedActive = 'var(--plasma-colors-button-checked-active, #080808)';
export var buttonCheckedActiveColor = 'var(--plasma-colors-button-checked-active-color, rgba(255, 255, 255, 0.6))';
/** Цвет рамки фокуса у контрола */
export var buttonFocused = 'var(--plasma-colors-button-focused, #2A72F8)';
/** Градиент для заливки основного фона */
export var gradient = 'var(--plasma-colors-gradient, linear-gradient(45deg, hsla(220.1123595505618, 85.57692307692307%, 59.21568627450981%, 1) 0%, hsla(189.78947368421052, 78.51239669421487%, 52.54901960784314%, 1) 100%))';
export var gradientDevice = 'var(--plasma-colors-gradient-device)';
export var voicePhraseGradient = 'var(--plasma-colors-voice-phrase-gradient)';
export var skeletonGradient = 'var(--plasma-colors-skeleton-gradient, linear-gradient( 90deg, rgba(8, 8, 8, 0.09) 0%, rgba(8, 8, 8, 0.08) 6.25%, rgba(8, 8, 8, 0.05) 12.5%, rgba(8, 8, 8, 0.01) 25%, rgba(8, 8, 8, 0.05) 37.5%, rgba(8, 8, 8, 0.08) 43.75%, rgba(8, 8, 8, 0.09) 50%, rgba(8, 8, 8, 0.08) 56.25%, rgba(8, 8, 8, 0.05) 62.5%, rgba(8, 8, 8, 0.01) 75%, rgba(8, 8, 8, 0.05) 87.5%, rgba(8, 8, 8, 0.08) 93.75%, rgba(8, 8, 8, 0.09) 100% ))';
export var skeletonGradientLighter = 'var(--plasma-colors-skeleton-gradient-lighter, linear-gradient( 90deg, rgba(8, 8, 8, 0.36) 0%, rgba(8, 8, 8, 0.32) 6.25%, rgba(8, 8, 8, 0.20) 12.5%, rgba(8, 8, 8, 0.04) 25%, rgba(8, 8, 8, 0.20) 37.5%, rgba(8, 8, 8, 0.32) 43.75%, rgba(8, 8, 8, 0.36) 50%, rgba(8, 8, 8, 0.08) 56.25%, rgba(8, 8, 8, 0.20) 62.5%, rgba(8, 8, 8, 0.04) 75%, rgba(8, 8, 8, 0.20) 87.5%, rgba(8, 8, 8, 0.32) 93.75%, rgba(8, 8, 8, 0.36) 100% ))';
export var speechBubbleSent = 'var(--plasma-colors-speech-bubble-sent)';
export var speechBubbleReceived = 'var(--plasma-colors-speech-bubble-received)';
/** Цвет фона паранжи */
export var overlay = 'var(--plasma-colors-overlay, rgba(0, 0, 0, 0.8))';
export var overlaySoft = 'var(--plasma-colors-overlay-soft, rgba(8, 8, 8, 0.56))';
export var overlayHard = 'var(--plasma-colors-overlay-hard, rgba(8, 8, 8, 0.9))';
export var overlayBlur = 'var(--plasma-colors-overlay-blur, rgba(35, 35, 35, 0.2))';
export var darkOverlaySoft = 'var(--plasma-colors-dark-overlay-soft, rgba(8, 8, 8, 0.56))';
export var darkOverlayHard = 'var(--plasma-colors-dark-overlay-hard, rgba(8, 8, 8, 0.9))';
export var darkOverlayBlur = 'var(--plasma-colors-dark-overlay-blur, rgba(35, 35, 35, 0.2))';
export var lightOverlaySoft = 'var(--plasma-colors-light-overlay-soft, rgba(8, 8, 8, 0.56))';
export var lightOverlayHard = 'var(--plasma-colors-light-overlay-hard, rgba(8, 8, 8, 0.9))';
export var lightOverlayBlur = 'var(--plasma-colors-light-overlay-blur, rgba(35, 35, 35, 0.2))';
export var inverseOverlaySoft = 'var(--plasma-colors-inverse-overlay-soft, rgba(8, 8, 8, 0.56))';
export var inverseOverlayHard = 'var(--plasma-colors-inverse-overlay-hard, rgba(8, 8, 8, 0.9))';
export var inverseOverlayBlur = 'var(--plasma-colors-inverse-overlay-blur, rgba(35, 35, 35, 0.2))';
//# sourceMappingURL=index.js.map